module.exports = __webpack_public_path__ + "media/bootstrap-icons/exclude-e98df506.svg";